<template>
  <div class="unsubscribe-page">
    <div class="unsubscribe-card">
      <h1>{{ $gettext('MSG_UNSUBSCRIBE_PAGE_TITLE') }}</h1>
      <!--
      <p class="subtitle">{{ $gettext('MSG_UNSUBSCRIBE_PAGE_SUBTITLE') }}</p>
      -->

      <div v-if="optOutStatus" class="result-banner" :class="`is-${optOutStatus}`">
        <span class="result-title">{{ statusTitle }}</span>
        <span v-if="optOutMessage" class="result-message">{{ optOutMessage }}</span>
      </div>

      <div v-if="pathVariable" class="path-variable">
        <span class="query-key">{{ $gettext('MSG_UNSUBSCRIBE_PATH_VARIABLE') }}</span>
        <span class="query-value">{{ pathVariable }}</span>
      </div>

      <!--
      <div v-if="queryEntries.length" class="query-list">
        <div v-for="entry in queryEntries" :key="entry.key" class="query-item">
          <span class="query-key">{{ entry.key }}</span>
          <span class="query-value">{{ entry.value }}</span>
        </div>
      </div>

      <div v-else class="empty-state">
        {{ $gettext('MSG_UNSUBSCRIBE_EMPTY_STATE') }}
      </div>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsubscribeLanding',
  data () {
    return {
      lastRequestedToken: null,
      optOutStatus: '',
      optOutMessage: ''
    }
  },
  props: {
    queryParams: {
      type: Object,
      default: () => ({})
    },
    pathVariable: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.callOptOutIfNeeded(this.queryParams.token)
  },
  watch: {
    'queryParams.token' (token) {
      this.callOptOutIfNeeded(token)
    }
  },
  methods: {
    async callOptOutIfNeeded (token) {
      const normalizedToken = typeof token === 'string' ? token.trim() : token

      if (!this.hasAnyVariable || !normalizedToken) {
        this.lastRequestedToken = null
        this.optOutStatus = 'error'
        this.optOutMessage = this.$gettext('MSG_UNSUBSCRIBE_INVALID_OR_EXPIRED_TOKEN')
        return
      }

      if (normalizedToken === this.lastRequestedToken) {
        return
      }

      this.lastRequestedToken = normalizedToken
      this.optOutStatus = 'loading'
      this.optOutMessage = this.$gettext('MSG_UNSUBSCRIBE_LOADING_MESSAGE')

      try {
        const response = await this.$axios.get('messaging/unsubscribe', {
          params: { token: normalizedToken }
        })

        const responseCode = this.extractBusinessCode(response)
        const responseMessage = this.extractMessage(response)

        if (responseCode === 200) {
          this.optOutStatus = 'success'
          this.optOutMessage = responseMessage
        } else {
          this.optOutStatus = 'error'
          this.optOutMessage = responseMessage || this.$gettext('MSG_UNSUBSCRIBE_GENERIC_ERROR')
        }
      } catch (error) {
        const status = error && error.response && error.response.status
        this.optOutStatus = 'error'
        this.optOutMessage = this.extractMessage(error && error.response)

        if (status === 400 || status === 429) {
          this.optOutMessage = this.optOutMessage || this.$gettext('MSG_UNSUBSCRIBE_INVALID_OR_EXPIRED_TOKEN')
        } else {
          this.optOutMessage = this.optOutMessage || this.$gettext('MSG_UNSUBSCRIBE_GENERIC_ERROR')
        }

        console.error('Erro ao chamar opt-out da mensageria:', error)
      }
    },
    extractMessage (response) {
      if (!response || typeof response.data === 'undefined' || response.data === null) {
        return ''
      }

      if (typeof response.data === 'string') {
        return response.data
      }

      if (typeof response.data.msg === 'string') {
        return response.data.msg
      }

      if (typeof response.data.message === 'string') {
        return response.data.message
      }

      return ''
    },
    extractBusinessCode (response) {
      if (!response || !response.data) {
        return null
      }

      const businessCode = Number(response.data.code)
      return Number.isNaN(businessCode) ? null : businessCode
    }
  },
  computed: {
    hasAnyVariable () {
      return Boolean(this.pathVariable) || Object.keys(this.queryParams).length > 0
    },
    queryEntries () {
      return Object.keys(this.queryParams).map(key => ({
        key,
        value: String(this.queryParams[key])
      }))
    },
    statusTitle () {
      if (this.optOutStatus === 'loading') {
        return this.$gettext('MSG_UNSUBSCRIBE_STATUS_LOADING')
      }

      if (this.optOutStatus === 'success') {
        return this.$gettext('MSG_UNSUBSCRIBE_STATUS_SUCCESS')
      }

      if (this.optOutStatus === 'error') {
        return this.$gettext('MSG_UNSUBSCRIBE_STATUS_ERROR')
      }

      return ''
    }
  }
}
</script>

<style scoped>
.unsubscribe-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #f3f8f6 0%, #e5efeb 100%);
  padding: 24px;
}

.unsubscribe-card {
  width: 100%;
  max-width: 760px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(14, 36, 28, 0.12);
  padding: 28px;
}

h1 {
  margin: 0;
  color: #1b4f3a;
  font-size: 28px;
  line-height: 1.2;
}

.subtitle {
  margin: 8px 0 20px;
  color: #51635a;
}

.result-banner {
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 14px;
  border: 1px solid transparent;
}

.result-banner.is-loading {
  background: #f6f8e8;
  border-color: #dce3af;
}

.result-banner.is-success {
  background: #eaf8f0;
  border-color: #b8e2c8;
}

.result-banner.is-error {
  background: #fdeeee;
  border-color: #f3b8b8;
}

.result-title {
  font-weight: 700;
  color: #1b4f3a;
}

.result-message {
  color: #2d3f36;
  word-break: break-word;
}

.query-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.path-variable {
  display: flex;
  gap: 10px;
  border: 1px solid #d5e2dc;
  border-radius: 8px;
  padding: 10px 12px;
  background: #eef7f3;
  align-items: center;
  margin-bottom: 10px;
}

.query-item {
  display: flex;
  gap: 10px;
  border: 1px solid #d5e2dc;
  border-radius: 8px;
  padding: 10px 12px;
  background: #f8fbfa;
  align-items: center;
}

.query-key {
  font-weight: 700;
  color: #1b4f3a;
  min-width: 180px;
  word-break: break-word;
}

.query-value {
  color: #2d3f36;
  word-break: break-word;
}

.empty-state {
  padding: 16px;
  border-radius: 8px;
  background: #f7faf8;
  border: 1px dashed #c6d8d0;
  color: #587064;
}

@media (max-width: 640px) {
  .unsubscribe-card {
    padding: 20px;
  }

  .query-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .query-key {
    min-width: auto;
  }
}
</style>
